import React from "react";
import httpClient from "../services/httpClient";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import ConfirmPromotionImage from "../images/pro_new_mem.jpg";

import { toast } from "react-hot-toast";
import { clearRegistrationPin, consumeRegistrationPin, hasConfirmedRegistrationPin } from "../services/registrationPin";

const MySwal = withReactContent(Swal);

const backgroundRounded = {
  backgroundImage:
    "linear-gradient(to right, #051937, #004d7a, #008793, #00bf72, #a8eb12)",
  borderRadius: "10px 10px 10px 10px",
};

const ConfirmPromotion = () => {
  const navigate = useNavigate();
  const [promotion, setPromotion] = React.useState(false);
  const [getPromotion, setGetPromotion] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const submission = React.useRef(null);
  const active = React.useRef(true);
  const alertPromotion = async () => {
    if (promotion) {
      setPromotion(false);
    } else {
      setPromotion(true);
    }
  };

  const getData = async () => {
    setLoading(true);
    try {
      const res1 = await httpClient.get("/authen/getPromotion");
      setGetPromotion(res1.data.data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = () => {
    if (promotion) {
      MySwal.fire({
        title: "โปรสมัครใหม่",
        html:
          "รับโบนัสฝากขั้นต่ำ 100 บาท โบนัสสูงสุด 500 บาท ทำเทิร์น 1 เท่า" +
          'ถอนสูงสุด 3,000 บาท <span style="color: red">เล่นได้เฉพาะสล็อตกับยิงปลาเท่านั้น</span>' +
          " ถ้าหากเล่นผิดกฎคืนเงินเท่ายอดฝากทุกกรณี กรณีที่มีเจตนาซ่อนฟรีสปินยอดทั้งหมดจะเป็นโมฆะ",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน!",
        cancelButtonText: "ยกเลิก",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await sendFinal();
        }
      });
    } else {
      MySwal.fire({
        title: "ไม่รับโบนัส?",
        text: "ไม่รับโบนัส ฝากไม่มีขั้นต่ำ ถอนขั้นต่ำ 100 บาท เล่นได้ทุกเกมส์ไม่จำกัด",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน!",
        cancelButtonText: "ยกเลิก",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await sendFinal();
        }
      });
    }
  };

  React.useEffect(() => {
    active.current = true;
    if (!localStorage.getItem("registerId")) {
      navigate("/", { replace: true });
    } else if (!hasConfirmedRegistrationPin()) {
      navigate("/create-pin", { replace: true });
    } else {
      getData();
    }
    return () => {
      active.current = false;
      submission.current?.abort();
      clearRegistrationPin();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sendFinal = async () => {
    if (submission.current) return;
    let pin = consumeRegistrationPin();
    if (!pin) {
      navigate("/create-pin", { replace: true });
      return;
    }
    const controller = new AbortController();
    submission.current = controller;
    let registered = false;
    try {
      setLoading(true);
      const res1 = await httpClient.post("/authen/register", {
        registerId: localStorage.getItem("registerId"),
        pinCode: pin,
        pinCode2: pin,
        promotionId: promotion ? getPromotion.promotion.id : 1,
      }, {
        headers: { "X-PGBunny-Registration": "pin-private-v1" },
        signal: controller.signal,
      });
      if (controller.signal.aborted || !active.current) return;
      registered = true;
      localStorage.removeItem("registerId");
      const resp = await httpClient.post("/authen/login", {
        phoneNumber: res1.data.data.phoneNumber,
        pinCode: pin,
      }, { signal: controller.signal });
      if (!active.current) return;
      localStorage.setItem("accessToken", resp.data.data.accessToken);
      navigate("/auth/dashboard");
    } catch (error) {
      if (active.current && !controller.signal.aborted) {
        toast.error(registered
          ? "สมัครสำเร็จแล้ว กรุณาเข้าสู่ระบบด้วย PIN ที่ตั้งไว้"
          : "สมัครไม่สำเร็จ กรุณาลองเข้าสู่ระบบหรือเริ่มสมัครใหม่");
        navigate("/login", { replace: true });
      }
    } finally {
      pin = "";
      clearRegistrationPin();
      submission.current = null;
      if (active.current) setLoading(false);
    }
  };
  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="boxTopRounded topBMargin boxSmRounded mb20">
            <span className="imgBonus">
              <img src={ConfirmPromotionImage} alt="banner" />
            </span>
            <div style={backgroundRounded} className="p-2 round">
              <div className="form-check form-switch ">
                <input
                  onClick={() => alertPromotion()}
                  className={`form-check-input checkbox-changer ${
                    promotion ? "active" : ""
                  }`}
                  type="checkbox"
                  id="switch"
                />
                <label className="form-check-label" htmlFor="switch">
                  ต้องการรับโบนัสหรือไม่?
                </label>
              </div>
            </div>
            <div className="d-grid gap-2 mt-2">
              {loading ? (
                <Button className="btn-block mt-3 btnPrimary" disabled>
                  กำลังโหลด
                </Button>
              ) : (
                <Button
                  className="btn-block mt-3 btnPrimary"
                  onClick={onSubmit}
                >
                  ยืนยัน
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPromotion;
